"use strict";
exports.__esModule = true;
var angular = require("angular");
var COMPONENT_NAME = 'smartorg.r6.reportOptions.headerText';
function formatGroupByColorByKeyDisplay(key, list_string) {
    if (!key || !list_string || !JSON.parse(list_string) || !JSON.parse(list_string).length) {
        return key;
    }
    var tagArr = JSON.parse(list_string)[0].split(':');
    if (tagArr.length === 3) {
        try {
            var codedName = tagArr[2];
            return atob(decodeURIComponent(codedName));
        }
        catch (e) {
            console.error('Error on dropdownTag name decoding!', e);
        }
    }
    return key;
}
var HeaderTextComponent = /** @class */ (function () {
    function HeaderTextComponent() {
        this.operatorMap = { '$gte': '>=', '$gt': '>', '$eq': '=', '$lt': '<', '$lte': '<=' };
    }
    HeaderTextComponent.prototype.$onChanges = function () {
        this.updateHeaderText();
    };
    HeaderTextComponent.prototype.updateHeaderText = function () {
        var _this = this;
        if (this.currentReportOptions) {
            var filterArray = (this.currentReportOptions.filterLogic || '').split(' and ');
            var validFilterArray = filterArray.map(function (filter) {
                if (!filter.includes(' or ') && filter.split(':').length === 6) {
                    return _this.formatNumericalFilterHeaderDisplay(filter);
                }
                else if (filter.split(' or ')[0].split(':').length === 3) {
                    return _this.formatDropdownCategoryHeaderDisplay(filter);
                }
                else {
                    return filter;
                }
            });
            var filters = validFilterArray.join(' and ');
            if (filters && filters.length > 50) {
                filters = filters.substr(0, 50) + '...';
            }
            var formatedGroupKey = formatGroupByColorByKeyDisplay(this.currentReportOptions.groupKey, this.currentReportOptions.groupByList);
            var formatedColorKey = formatGroupByColorByKeyDisplay(this.currentReportOptions.colorKey, this.currentReportOptions.colorByList);
            this.optionHeader = {
                filters: filters || null,
                groupby: formatedGroupKey || null,
                colorby: formatedColorKey || null,
                compareTo: this.currentReportOptions.compareToNodeName || null
            };
            this.showBreadcrumb = this.optionHeader.filters ||
                this.optionHeader.groupby ||
                this.optionHeader.colorby ||
                this.optionHeader.compareTo || false;
        }
        else {
            this.showBreadcrumb = false;
        }
    };
    HeaderTextComponent.prototype.formatNumericalFilterHeaderDisplay = function (filter) {
        var filterGrids = filter.split(':');
        var field = filterGrids[0], key = filterGrids[1], operator = filterGrids[2], value = filterGrids[3], template = filterGrids[4], codedDisplay = filterGrids[5];
        var display = atob(codedDisplay);
        return display ? [display, this.operatorMap[operator], value].join(' ') : [key, this.operatorMap[operator], value].join(' ');
    };
    HeaderTextComponent.prototype.formatDropdownCategoryHeaderDisplay = function (filterStr) {
        var filterLogicArr = filterStr.split(' ');
        var headerArr = filterLogicArr.map(function (f) {
            if (f.split(':').length !== 3) {
                return f;
            }
            var _a = f.split(':'), key = _a[0], codedVal = _a[1], codedName = _a[2];
            if (f.startsWith('(')) {
                return '((' + atob(decodeURIComponent(codedName)) + ':' + atob(decodeURIComponent(codedVal)) + ')';
            }
            if (f.endsWith(')')) {
                return '(' + atob(decodeURIComponent(codedName.slice(0, -1))) + ':' + atob(decodeURIComponent(codedVal)) + '))';
            }
            return '(' + atob(decodeURIComponent(codedName)) + ':' + atob(decodeURIComponent(codedVal)) + ')';
        });
        return headerArr.join(' ');
    };
    return HeaderTextComponent;
}());
angular.module(COMPONENT_NAME, []).component("headerText", {
    template: require("./header-text.component.html"),
    bindings: {
        currentReportOptions: '<',
        showSpinner: '<',
        showAlert: '&?'
    },
    controller: HeaderTextComponent
});
exports["default"] = COMPONENT_NAME;
//# sourceMappingURL=header-text.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/navigation/report-options2/header-text/header-text.component.js